import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import './resourcecost.css'
import {
  Header,
} from '@backstage/core-components';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'ag-grid-enterprise';
import { Button, Tooltip } from '@mui/material';
import Loader from '../loader/Loader';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Box, IconButton, Typography, makeStyles } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { discoveryApiRef, useApi, fetchApiRef, identityApiRef } from '@backstage/core-plugin-api';
import DropdownComponent from './DropdownComponent';


const useStyles = makeStyles({
  accountIdFilterBoxApplied: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '5px',
    border: '1px solid #1F5493',
    color: 'black',
    borderRadius: '25px',
    fontSize: '8px',
    marginRight: '10px',
    backgroundColor: '#1F5493'
  },
  accountIdFilterBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '5px',
    border: '1px solid #1F5493',
    color: '#1F5493',
    borderRadius: '25px',
    fontSize: '8px',
    marginRight: '10px',
    backgroundColor: 'white '
  },
  accountIdFilterIcon: {
    fontSize: '1.25rem',
    cursor: 'pointer',
  },
  accountIdFilterButtonApplied: {
    padding: 0,
    marginLeft: '5px',
    fontSize: '15px',
    color: 'white'
  },
  accountIdFilterButtonNotApplied: {
    padding: 0,
    marginLeft: '5px',
    fontSize: '15px',
  },
  liveresourceFilter: {
    backgroundColor: '#1F5493',
    color: "white",
    fontSize: '12px',
    height: '35px',
    marginRight: '-15px',
    borderRadius: '25px',
  },
  liveresourcebutton: {
    fontSize: 'larger',
    height: '35px',
    textTransform: 'none',
    marginRight: '10px',
    borderRadius: '25px',
    color: '#1F5493',
    border: 'none',
    fontWeight: 'bold'
  },
  liveboxclick: {
    width: '150px',
    height: '35px',
    backgroundColor: '#1F5493',
    borderRadius: '25px',
    marginRight: '10px',
  },
  livebox: {
    height: '35px',
    backgroundColor: 'white',
    borderRadius: '25px',
    marginRight: '10px'
  },
  costBox1: {
    display: 'flex',
    marginLeft: '0px',
    justifyContent: 'space-between',
    marginRight: '0px' ,
    fontWeight: 'bold',
  },
  costBox3: {
    display: 'flex',
  },
  costBox2: {
    display: "flex",
    flex: 'none',
    alignItems: "center",
    fontWeight: 'bold',
    height: '34px',
    marginLeft:'10px',
    border: '1px solid #1F5493',
    padding: '10px',
    borderRadius: '25px',
    backgroundColor: 'white',
    marginRight: '10px'
  },
  costText: {
    fontWeight: 'bold',
    color: '#1F5493',
    fontSize: 'larger'
  },
  payerBox: {
    display: "flex",
    flex: 'none',
    alignItems: "center",
    fontWeight: 'bold',
    height: '34px',
    marginLeft: '10px',
    border: '1px solid #1F5493',
    padding: '10px',
    borderRadius: '25px',
    backgroundColor: 'white',
    marginTop: '30px',
  }, 
  iconButton: {
    color: '#1F5493 !important', // Custom color for the calendar icon button
  },
  notchedOutline: {
    borderColor: '#1F5493 !important', // Custom border color for the datepicker input
    border: '1px solid !important',
  },
  inputLabel: {
    color: '#1F5493 !important',
    fontWeight: 'bold !important', // Custom label styling
  },
})

const ResourceCostPage = () => {
  const styles = useStyles();
  const gridRef = useRef<any>(null);
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh", }), []);
  const gridStyle = useMemo(() => ({ height: '100vh', width: "100%", marginTop: '10px' }), []);
  const [rowData, setRowdata] = useState([]);
  const [role, setRole] = useState('')
  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());
  const [loading, setLoading] = useState(true)
  const [filterApplied, setFilterApplied] = useState(false);
  const [filteredData, setFilteredData] = useState([])
  const [org, setOrg] = useState('')
  const [updatedData, setUpdatedData] = useState([])
  const [liveresource, setLiveResource] = useState([])
  const [liveresourceClicked, setLiveresourceClicked] = useState(false)
  const [totalCostValue, setTotalCost] = useState<number>(0)
  const [forecastedCost, setForecastedCost] = useState<number>(0)
  const [accountsData, setAccountsData] = useState<any>([])
  const [payerAccountId, setPayerAccountId] = useState('');
  const [payerAccountName, setPayerAccountName] = useState('')
  const [cpuUtilizations, setCpuUtilizations] = useState([]);
  const [payerData, setPayerData] = useState({})
  const [showColumn, setShowColumn] = useState(false)
  const [isCurrentMonth, setIsCurrentMonth] = useState(true)
  const [ showEstimate, setShowEstimate] = useState(true)
  const [selectedTenant, setSelectedTenant] = useState<number>(0)
  const fetchApi = useApi(fetchApiRef);
  const [tenantsFromDb, setTenantsFromDb] = useState<any[]>([]);
  const identityApi = useApi(identityApiRef)
  
  const fetchTenantsFromDb = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      const response = await fetchApi.fetch(`${baseUrl}/tenants`);
      if (!response.ok) throw new Error("Failed to fetch tenants");
      return await response.json();
    } catch (e) {
      console.error("Error fetching tenants:", e);
      return [];
    }
  };

  const fetchTenant = async () => {
    try {
      const details = await identityApi.getBackstageIdentity();
      const id = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('tenantId:')
      )?.split(':')[1] || null;

      console.log("ID ---------", id)
      return id
    } catch (err) {
      console.error('Failed to get tenantId:', err);
    }
  }; 
  
  const tenantOptions = useMemo(() => {
    if (!rowData || rowData.length === 0) return [];
    const uniqueTenants = Array.from(new Set(rowData.map((row: any) => row.tenantName)));
    return uniqueTenants.map(tenantName => ({
      label: tenantName, // or replace with row.tenantName if you have it
      value: tenantName,
    }));
  }, [rowData]);


  const [selectedDropdownOption, setSelectedDropdownOption] = useState('')
  const [dropdownOptions, setDropdownOptions] = useState([
    { value: 'product/servicename', label: 'Service Name' },
    { value: 'resourceTags/user:Environment', label: 'Environment' },
    { value: 'resourceTags/user:Application', label: 'Application' },
    { value: 'resourceTags/user:Created-By', label: 'Created-by' },
    { value: 'none', label: 'None' }
  ]);

  const searchParams = new URLSearchParams(window.location.search);
  const accountId = searchParams.get('accountId');
  const discoveryApi = useApi(discoveryApiRef)


  const onGridReady = async (params: any) => {
    try {
      if (accountId) {
        const filterOnAccountIds = {
          "lineItem/UsageAccountId": {
            type: 'equals',
            filter: accountId
          }
        }
        gridRef.current!.api.setFilterModel(filterOnAccountIds);
        setFilterApplied(true)

        if (gridRef.current && gridRef.current.api)
          gridRef.current.api.addEventListener('columnRowGroupChanged', onColumnRowGroupChanged);
      }
    }
    catch (error) {
      console.log(error, 'error')
    }

  }



  const mergeRelatedData = (data: any) => {
    let alldata = data;

    let childs = alldata.filter((row: any) => {
      return row["relatedEntity"] != null
    })

    let mergedData = alldata.map((parent: any) => {
      const newRow = { ...parent };

      childs.forEach((child: any) => {
        if (parent['lineItem/ResourceId'] === child['relatedEntity'] && newRow.instanceType) {

          if (newRow['childrens']) {
            newRow['childrens'].push(child);
          } else {
            newRow['childrens'] = [child];
          }
        }
      });

      return newRow;
    });

    const sampleData = mergedData.filter((data) => { return data.childrens })

    return mergedData;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tenants = await fetchTenantsFromDb();
        const id = await fetchTenant()
        console.log(`orgName:${id}`)
        const tenantOrgName = localStorage.getItem(`orgName:${id}`);
        console.log('tenantOrgName------',tenantOrgName)
        if (tenantOrgName) setOrg(tenantOrgName);
        setTenantsFromDb(tenants);
        const baseurl = await discoveryApi.getBaseUrl('user')
        const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD');
        const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD')

        const currentMonth = dayjs().month(); // 0-based index for month (0 = January)
        const currentYear = dayjs().year();
      
        // Extract month and year from the formatted start and end dates
        const startMonth = dayjs(startDate).month();
        const startYear = dayjs(startDate).year();
        const endMonth = dayjs(endDate).month();
        const endYear = dayjs(endDate).year();
      
        // Check if the dates are in the current month and year
        const isCurrentMonthCheck = (startMonth === currentMonth && startYear === currentYear) &&
                                    (endMonth === currentMonth && endYear === currentYear);
      
        // Update the state based on the check
        setIsCurrentMonth(isCurrentMonthCheck);
        setShowEstimate(isCurrentMonthCheck);
        console.log(formattedStartDate, formattedEndDate, 'formatted start date and end date inside resourcecost')
        // const response = await axios.post(`${baseurl}/groupbycost`, {
        //   startDate: formattedStartDate,
        //   endDate: formattedEndDate
        // });
        let fetchdata = []
        try {
            const fetchresponse = await fetchApi.fetch(`${baseurl}/groupbycost`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                startDate: formattedStartDate,
                endDate: formattedEndDate,
              }),
            });
            if (!fetchresponse.ok) {
              const errorText = await fetchresponse.text();
              throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
            }
            let response = await fetchresponse.json();
            let role = response.role
            setRole(role)
            fetchdata = response.data || []
            console.log('Fetched data:', fetchdata);
          // ...rest of your code...
        } catch (error) {
          console.error('Fetch or JSON parse error:', error);
        }
        const data = fetchdata
        console.log(data["bill/PayerAccountId"])
        setPayerAccountId(data["bill/PayerAccountId"])
        setPayerAccountName(data["bill/PayerAccountId_AccountName"])

        const extractedData = data.length > 0 ? data[0] : {};
        const payerData = {
          column1: extractedData["bill/PayerAccountId"], // Replace 'column1' with the actual name of the first column
          column2: extractedData["bill/PayerAccountId_AccountName"], // Replace 'column2' with the actual name of the second column
        };

        setPayerData(payerData)

        const filteredData: any = data
          .filter((row: any) => row.TotalCost !== 0)
          .map((row: any) => {
            const newRow = { ...row };
            if (newRow['lineItem/UsageAccountId']) {
              newRow['lineItem/UsageAccountId'] = newRow['lineItem/UsageAccountId'].split('.')[0];
            }
            return newRow;
          });

        const mergedData = mergeRelatedData(filteredData)
        setFilteredData(mergedData)
        const liveResources = mergedData.filter((item: any) => item['lineItem/ResourceId'] !== null && item['resource/deletionDate'] === null);
        const liveData = calculateEstimatedCost(liveResources, startDate, endDate)
        setLiveResource(liveResources);
        const updatedData = calculateEstimatedCost(mergedData, startDate, endDate)
        if (liveresourceClicked) {
          setRowdata(liveData);
          console.log("liveData", liveData)
        }
        else {
          setRowdata(updatedData);
          console.log("updatedData", updatedData)

        }
        setUpdatedData(updatedData)

        setLoading(false)
      } catch (error) {
        setLoading(false)
      }

    };

    fetchData();
    let orgName = localStorage.getItem('orgName')
    if (orgName) {
      setOrg(orgName)
    }
  }, [startDate, endDate]);

  // useEffect(() => {
  //   getAllAccounts();
  // }, [filterApplied, startDate, endDate])


  useEffect(() => {
    getMaxUtilization()
  }, [])

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      const api = gridRef.current.api;
      let columnDefs = api.getColumnDefs();

      // Check if the column has already been added
      const columnExists = columnDefs.some(column => column.field === 'estimatedCost');
      
      if (columnExists) {
        // Find the column definition and set its hide property
        const updatedColumnDefs = columnDefs.map(column => {
          if (column.field === 'estimatedCost') {
            return { ...column, hide: !isCurrentMonth }; // Hide based on isCurrentDate
          }
          return column; // Return other columns unchanged
        });

        // Update the grid with the new column definitions
        api.setColumnDefs(updatedColumnDefs);
      }
    }
  }, [isCurrentMonth]); 

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      const api = gridRef.current.api;
      let columnDefs = api.getColumnDefs();

      // Check if the column has already been added
      const columnExists = columnDefs.some(column => column.field === 'maxCPU');

      if (!columnExists) {
        // Define the new column
        const newColumn = {
          headerName: 'Max CPU Utilization',
          field: 'maxCPU', // Assuming newField exists in your data
          valueGetter: maxCpuUtilizationValueGetter, // Use your custom cell renderer
          headerTooltip: "Max CPU Utilization",
          minWidth: 150
        };

        // Specify the position where you want to insert the new column
        const insertAtIndex = 14; // For example, insert at index 2

        // Insert the new column at the specified position
        columnDefs.splice(insertAtIndex, 0, newColumn);

        // Update the column definitions
        api.setColumnDefs(columnDefs);
      }
    }
  }, [showColumn]); // Dependency on rowData

  const calculateForecastedCost = (costTillToday: number, startDate, endDate) => {
    try {
        const firstDay = new Date(startDate);
        const lastDay = new Date(endDate);
        
        // Calculate the total number of days from startDate to endDate
        let totalDays = Math.ceil((lastDay.getTime() - firstDay.getTime()) / (1000 * 60 * 60 * 24));
        
        // Handle the case where startDate and endDate are the same
        if (totalDays === 0) {
            totalDays = 1;
        }

        // Calculate the cost per day
        const costPerDay = parseFloat((costTillToday / totalDays).toFixed(2));

        let totalDaysInPeriod;

        // Determine the total days in the period to forecast
        if (firstDay.getMonth() === lastDay.getMonth() && firstDay.getFullYear() === lastDay.getFullYear()) {
            // If startDate and endDate are in the same month and year
            totalDaysInPeriod = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0).getDate();
        } else {
            // If startDate and endDate are in different months or years
            totalDaysInPeriod = totalDays + 1; // Include both startDate and endDate
        }

        // Handle the case where totalDaysInPeriod is 0
        if (totalDaysInPeriod === 0) {
            totalDaysInPeriod = 1;
        }

        // Calculate the forecasted cost
        return parseFloat((costPerDay * totalDaysInPeriod).toFixed(2));
    } catch (error) {
        console.error('Error calculating forecasted cost:', error);
        return 0; // Return 0 or another default value if an error occurs
    }
};


  const formatData = (data: any[], startDate, endDate) => {
    const formattedData: any[] = [];
    let totalCost = 0;
    if (filterApplied) {
      const acc = data.filter(acc => acc.AccountId === accountId)
      totalCost = acc[0].TotalCost

      setTotalCost(parseFloat(totalCost.toFixed(2)))
      setForecastedCost(calculateForecastedCost(totalCost, startDate, endDate))
    } else {
      data.forEach((account: any) => {
        if (account.awsAccount) {
          formattedData.push(account)
          totalCost += Number(account.awsAccount.TotalCost);
        } else {
          formattedData.push({ awsAccount: account })
          totalCost += Number(account.TotalCost);
        }
      })
      setTotalCost(parseFloat(totalCost.toFixed(2)));
      setForecastedCost(calculateForecastedCost(totalCost, startDate, endDate));
      return formattedData;
    }
  }


  const getMaxUtilization = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user')
      // const response = await axios.get(`${baseUrl}/cpu-utilization`)

      let data = []
      try {
        const fetchresponse = await fetchApi.fetch(`${baseUrl}/cpu-utilization`, {
          method: 'GET',
        });
        if (!fetchresponse.ok) {
          const errorText = await fetchresponse.text();
          throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
        }
        data = await fetchresponse.json();
        console.log('Fetched data:', data);
      } catch (error) {
        console.error('Fetch or JSON parse error:', error);
      }
      console.log(data, 'response data')
      setCpuUtilizations(data)
      setShowColumn(true)
    }
    catch (error) {
      console.error("error", error)
    }
  }

  // const getAllAccounts = async () => {
  //   // const today = new Date();
  //   // const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  //   const baseUrl = await discoveryApi.getBaseUrl('user')
  //   const formattedStartDate = dayjs(startDate).format('YYYY-MM-DD');
  //   const formattedEndDate = dayjs(endDate).format('YYYY-MM-DD')
  //   // const awsAccounts = await axios.post(`${baseUrl}/getaccountcost`, {
  //   //   startDate: formattedStartDate,
  //   //   endDate: formattedEndDate
  //   // })

  //   let data = []
  //   try {
  //     const fetchresponse = await fetchApi.fetch(`${baseUrl}/getaccountcost`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         startDate: formattedStartDate,
  //         endDate: formattedEndDate,
  //       }),
  //     });
  //     if (!fetchresponse.ok) {
  //       const errorText = await fetchresponse.text();
  //       throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
  //     }
  //     data = await fetchresponse.json();
  //     console.log('Fetched data:', data);
  //   } catch (error) {
  //     console.error('Fetch or JSON parse error:', error);
  //   }
  //   console.log("AWS accounts", data)
  //   setAccountsData(formatData(data, formattedStartDate, formattedEndDate))
  //   return data;
  // }

  const calculateEstimatedCost = (filteredData: any, startDate: Date, endDate: Date) => {

    const updatedData = filteredData.map((row: any) => {
      const { 'TotalCost': cost, 'lineItem/ResourceId': resourceId, 'resource/creationDate': creationDate, 'resource/deletionDate': deletionDate } = row;
      const isStartDateFirstDayOfMonth = startDate.getDate() === 1;
      const isEndDateWithinSameMonth = endDate.getMonth() === startDate.getMonth() && endDate.getFullYear() === startDate.getFullYear();

      if (!isStartDateFirstDayOfMonth || !isEndDateWithinSameMonth) {
        return { ...row, estimatedCost: 'NA' };
      }
      if (resourceId === null) {
        return { ...row, estimatedCost: 'NA' };
      }
      const parsedCreationDate = creationDate !== null ? new Date(creationDate) : null;
      const parsedDeletionDate = deletionDate !== null ? new Date(deletionDate) : null
      const date1 = (parsedCreationDate === null || parsedCreationDate.getTime() < startDate.getTime()) ? startDate.getDate() : parsedCreationDate?.getDate()
      const date2 = parsedDeletionDate === null ? endDate.getDate() : parsedDeletionDate.getDate()
      const daysDiff = date2 - date1 + 1
      const lastDayOfMonth = getLastDayOfMonth(startDate);
      const multiplicationFactor = parsedDeletionDate === null ? lastDayOfMonth - date1 + 1 : date2 - date1 + 1
      const estimatedCost = (cost / daysDiff) * multiplicationFactor;
      if (isNaN(estimatedCost) || !isFinite(estimatedCost)) {
        return { ...row, estimatedCost: 'NA' };
      }
      return { ...row, estimatedCost };
    });
    return updatedData;
  }

  const getLastDayOfMonth = (startDate: any) => {
    const year = startDate.getFullYear();
    const month = startDate.getMonth();
    const lastDayOfMonth = new Date(year, month + 1, 0);
    return lastDayOfMonth.getDate();
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1, filter: true, sortable: true, resizable: true, enableRowGroup: true,
    };
  }, []);

  const autoGroupColumnDef = {
    headerName: 'Group',
    minWidth: 250,
    resizable: true,
    tooltipValueGetter: (p: any) => p.value
  }

  const formatCellValue = (params: any) => {
    if (params && params.node.group) {
      return params.value
    }
    else {
      return params.value ? params.value : "NA"
    }
  }

  const estimatedCostFormatter = (params: any) => {
    // if (!params.node.group) {
    if (params && params.value && params.value !== 'NA') {
      let formattedCost = parseFloat(params.value.toFixed(3));
      if (formattedCost >= 0.001 && formattedCost <= 0.01) {
        formattedCost = 0.01
      }
      return formattedCost.toFixed(2);
    }
    // }
    return "NA";
  }

  const CustomCostRenderer = (params: any) => {
    if (params && params.value && params.value !== 'NA') {
      let roundedValue = parseFloat(params.value.toFixed(3));
      if (roundedValue >= 0.001 && roundedValue <= 0.01) {
        roundedValue = 0.01
      }
      return roundedValue.toFixed(2);
    }
    return '';
  };


  function accountNameValueGetter(params: any) {
    if (!params.node.group)
      return `${params.data['lineItem/UsageAccountId_AccountName']} (${params.data['lineItem/UsageAccountId']})`;;
  }

  function EbsValueGetter(params: any) {
    if (params.node.group) {
      // If the node is a group node, return an empty string
      return '';
    } else {
      // Check if the value of 'columnA' starts with 'vol'
      const columnValue = params.data['lineItem/ResourceId'];
      if (columnValue && columnValue.startsWith('vol')) {
        // Return 'ebs volume' if the condition is true
        return 'EBS Volume';

      } else if (columnValue && columnValue.startsWith('i-')) {
        return 'EC2 Instance';
      }
      else {
        // Otherwise, return an empty string
        return 'NA';
      }
    }
  }

  const maxCpuUtilizationValueGetter = (params) => {
    if (!params.node.group) {
      const instanceId = params.data['lineItem/ResourceId'];
      if (!instanceId) {
        return 'NA'; // If instance ID is not present, return empty string
      }

      const cpuUtilizationData = cpuUtilizations.find(item => item.instanceId === instanceId);

      return cpuUtilizationData ? cpuUtilizationData.maxCPU.toFixed(2) : 'NA'; // Return CPU utilization value for the instance ID if found
    }

  };


  const columnDefs = useMemo(() => {
    const baseCols = [
    { headerName: "Tenant Name", field: "tenantName", headerTooltip: "Tenant Name", rowGroup: true },
    {
      headerName: "Payer Account Id", field: "bill/PayerAccountId", headerTooltip: "Payer Account Id",
      cellRenderer: 'agGroupCellRenderer', valueFormatter:
        (params: any) => {
          // if (params.node.rowIndex === params.api.getDisplayedRowCount() - 1 && !params.value) {
          //   return 'Total';
          // }
          // else {
          const number = parseInt(params.value)
          if (!isNaN(number)) { return Math.round(number) }
          else { return params.value; }

          // }

        },
      tooltipValueGetter: (p: any) => p.value, hide: true

    },
    { headerName: 'Service Name', field: "product/servicename", headerTooltip: "Service Name", minWidth: 250, valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value, cellRenderer: 'agGroupCellRenderer' },

    {
      headerName: 'Account Name', field: "lineItem/UsageAccountId_AccountName", minWidth: 250, headerTooltip: "Account Name", valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value,
      valueGetter: accountNameValueGetter
    },
    {
      headerName: 'Usage Account Id', field: "lineItem/UsageAccountId", headerTooltip: "Usage Account Id", hide: true,
      tooltipValueGetter: (p: any) => p.value,
      filter: accountId ? 'agTextColumnFilter' : 'agSetColumnFilter',
    },
    { headerName: 'Resource Id', field: "lineItem/ResourceId", minWidth: 250, headerTooltip: "Resource Id", valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
    {
      headerName: 'Incurred Cost ($)', field: "TotalCost", headerTooltip: "Incurred Cost ($)", minWidth: 150, cellRenderer: CustomCostRenderer, tooltipValueGetter: (p: any) => p.value, aggFunc: 'sum', cellClass: 'cost-cell', sort: 'desc',
      filterParams: {
        textFormatter: (params: any) => {
          const initialValue = params.value <= 0.003 ? 0.01 : params.value;
          const fixedValue = initialValue.toFixed(2);
          return `${params.value} (Rounded:${fixedValue})`
        },
      }
    },
    { headerName: 'Estimated Cost', field: "estimatedCost", headerTooltip: "Estimation Cost for this month", minWidth: 150, aggFunc: 'sum', valueFormatter: estimatedCostFormatter, tooltipValueGetter: (p: any) => p.value },
    { headerName: 'Resource Type', field: "ebsvolume", headerTooltip: "Resource Type", minWidth: 150, valueGetter: EbsValueGetter, tooltipValueGetter: (p: any) => p.value },
    { headerName: 'Region', field: "product/region", headerTooltip: "Region", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
    { headerName: 'Instance Type', field: "instanceType", headerTooltip: "Instance Type", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },
    { headerName: 'Module', field: "resourceTags/user:module", headerTooltip: "module", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
    { headerName: 'Created By', field: "resourceTags/user:Created-By", headerTooltip: "Created By", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
    { headerName: 'Application', field: "resourceTags/user:Application", headerTooltip: "application", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
    {
      headerName: 'Environment',
      field: "resourceTags/user:Environment",
      headerTooltip: "Environment",
      minWidth: 150,
      valueGetter: (params: any) => {
        if (!params.node.group) {
          const environment = params.data["resourceTags/user:Environment"];
          const costCenter = params.data["resourceTags/user:costcenter"];

          // Prioritize Environment, fallback to CostCenter if Environment is null or undefined
          if (environment !== null && environment !== undefined) {
            return ` ${environment}`;
          } else if (costCenter !== null && costCenter !== undefined) {
            return ` ${costCenter}`;
          } else {
            return 'NA'; // Return an empty string if both values are null or undefined
          }
        }
      },
      valueFormatter: (params: any) => params.value,
      tooltipValueGetter: (p: any) => p.value
    },
    { headerName: 'Creation Date', field: "resource/creationDate", headerTooltip: "Creation Date", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },
    { headerName: 'Deletion Date', field: "resource/deletionDate", headerTooltip: "Deletion Date", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },
    { headerName: 'Entity Relation', field: "relatedEntity", headerTooltip: "Entity Relation", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },
  ];
  
  return baseCols.map(col =>
    col.field === "tenantName"
      ? { ...col, hide: role != "SuperAdmin", rowGroup: role != "SuperAdmin" ? false : col.rowGroup }
      : col
  );
}, [role]);

  const sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      }
    ],
    defaultToolPanel: '',
  }

  function getDefaultStartDate() {
    const currentDate = new Date();
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    return startDate;
  }

  function getDefaultEndDate() {
    const today = new Date();
    const endDate = new Date(today);
    return endDate;
  }

  const handleClearAllFilters = (type: string) => {
    if (type === 'clearFilter') {
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.setFilterModel(null);
        if (liveresourceClicked) {
          setRowdata(updatedData)
          setLiveresourceClicked(false)
        }
        const columnApi = gridRef.current.columnApi;
        if (columnApi.getColumn("lineItem/UsageAccountId").getColDef().filter !== 'agSetColumnFilter') {
          const columnDefs = columnApi.getAllGridColumns().map((column: any) => {
            if (column.getColDef().field === "lineItem/UsageAccountId") {
              return {
                ...column.getColDef(),
                filter: 'agSetColumnFilter'
              };
            }
            return column.getColDef();
          });
          gridRef.current.api.setColumnDefs(columnDefs);
          setFilterApplied(false)
        }
      }

    }
    if (type === 'liveresource') {
      if (gridRef.current && gridRef.current.api) {
        // gridRef.current.api.setFilterModel(null);
        if (liveresourceClicked) {
          setRowdata(updatedData)
          setLiveresourceClicked(false)
        }
      }
    }
    if (type === 'column') {
      const columnApi = gridRef.current.columnApi;
      if (columnApi.getColumn("lineItem/UsageAccountId").getColDef().filter !== 'agSetColumnFilter') {
        const columnDefs = columnApi.getAllGridColumns().map((column: any) => {
          if (column.getColDef().field === "lineItem/UsageAccountId") {
            return {
              ...column.getColDef(),
              filter: 'agSetColumnFilter'
            };
          }
          return column.getColDef();
        });
        gridRef.current.api.setColumnDefs(columnDefs);
        setFilterApplied(false)
      }
    }

  }

  const handleLiveResources = () => {
    const liveresourceData = calculateEstimatedCost(liveresource, startDate, endDate)
    setRowdata(liveresourceData);
    setLiveresourceClicked(true)
  }

  const handleStartDateChange = (date: any) => {
    const newDate = new Date(date)
    setStartDate(newDate);
  }

  const handleEndDateChange = (date: any) => {
    const newDate = new Date(date)
    setEndDate(newDate);
  }

  const handleToggleFilter = () => {
    if (filterApplied) {
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.setFilterModel(null);
        setFilterApplied(false)
      }
    } else {
      const filterOnAccountIds = {
        "lineItem/UsageAccountId": {
          type: 'contains',
          filter: accountId
        }
      }
      if (gridRef.current && gridRef.current.api) {
        gridRef.current!.api.setFilterModel(filterOnAccountIds);
        setFilterApplied(true)
      }
    }
  }



  const detailCellRendererParams = useMemo(() => {
    return {

      detailGridOptions: {
        suppressRowClickSelection: true,
        suppressContextMenu: true,
        columnDefs: [
          {
            headerName: "Payer Account Id", field: "bill/PayerAccountId", headerTooltip: "Payer Account Id", valueFormatter:
              (params: any) => {
                if (params.node.rowIndex === params.api.getDisplayedRowCount() - 1 && !params.value) {
                  return 'Total';
                }
                else {
                  const number = parseInt(params.value)
                  if (!isNaN(number)) { return Math.round(number) }
                  else { return params.value; }

                }

              },
            tooltipValueGetter: (p: any) => p.value, hide: true

          },
          { headerName: 'Service Name', field: "product/servicename", headerTooltip: "Service Name", minWidth: 250, valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
          {
            headerName: 'Usage Account Id', field: "lineItem/UsageAccountId", headerTooltip: "Usage Account Id", hide: true,
            tooltipValueGetter: (p: any) => p.value,
            filter: accountId ? 'agTextColumnFilter' : 'agSetColumnFilter',
          },
          {
            headerName: 'Account Name', field: "lineItem/UsageAccountId_AccountName", minWidth: 250, headerTooltip: "Account Name", valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value,
            valueGetter: accountNameValueGetter
          },
          { headerName: 'Resource Id', field: "lineItem/ResourceId", minWidth: 150, headerTooltip: "Resource Id", valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
          {
            headerName: 'Incurred Cost ($)', field: "TotalCost", minWidth: 100, headerTooltip: "Incurred Cost ($)", cellRenderer: CustomCostRenderer, tooltipValueGetter: (p: any) => p.value, aggFunc: 'sum', cellClass: 'cost-cell', sort: 'desc',
            filterParams: {
              textFormatter: (params: any) => {
                const initialValue = params.value <= 0.003 ? 0.01 : params.value;
                const fixedValue = initialValue.toFixed(2);
                return `${params.value} (Rounded:${fixedValue})`
              },
            }
          },
          { headerName: 'Estimated Cost', field: "estimatedCost", minWidth: 100, headerTooltip: "Estimation Cost for this month", aggFunc: 'sum', valueFormatter: estimatedCostFormatter, tooltipValueGetter: (p: any) => p.value },

          { headerName: 'Resource Type', field: "ebsvolume", minWidth: 150, headerTooltip: "Resource Type", valueGetter: EbsValueGetter, tooltipValueGetter: (p: any) => p.value },
          { headerName: 'Region', field: "product/region", headerTooltip: "Region", minWidth: 150, valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },

          { headerName: 'Instance Type', field: "instanceType", minWidth: 150, headerTooltip: "Instance Type", valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },
          { headerName: 'Module', field: "resourceTags/user:module", minWidth: 150, headerTooltip: "module", valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
          { headerName: 'Created By', field: "resourceTags/user:Created-By", minWidth: 150, headerTooltip: "Created By", valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
          { headerName: 'Application', field: "resourceTags/user:Application", minWidth: 150, headerTooltip: "application", valueFormatter: formatCellValue, tooltipValueGetter: (p: any) => p.value },
          {
            headerName: 'Environment',
            field: "resourceTags/user:Environment",
            headerTooltip: "environment",
            minWidth: 150,
            valueGetter: (params: any) => {
              if (!params.node.group) {
                const environment = params.data["resourceTags/user:Environment"];
                const costCenter = params.data["resourceTags/user:costcenter"];

                // Prioritize Environment, fallback to CostCenter if Environment is null or undefined
                if (environment !== null && environment !== undefined) {
                  return ` ${environment}`;
                } else if (costCenter !== null && costCenter !== undefined) {
                  return ` ${costCenter}`;
                } else {
                  return 'NA'; // Return an empty string if both values are null or undefined
                }
              }
            },
            valueFormatter: (params: any) => params.value,
            tooltipValueGetter: (p: any) => p.value
          },
          { headerName: 'Creation Date', field: "resource/creationDate", minWidth: 150, headerTooltip: "Creation Date", valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },
          { headerName: 'Deletion Date', field: "resource/deletionDate", minWidth: 150, headerTooltip: "Deletion Date", valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },
          { headerName: 'Entity Relation', field: "relatedEntity", minWidth: 150, headerTooltip: "Entity Relation", valueFormatter: formatCellValue, tooltipValueGetter: (p) => p.value },

        ],
        defaultColDef: {
          flex: 1,

        },
      },
      getDetailRowData: (params: any) => {
        params.successCallback(params.data.childrens);
      },
    }
  }, []);


  const isRowMaster = (params: any) => {
    return params.childrens;
  };

  const handleDropdownChange = (event) => {
    const selectedField = event.target.value;
    setSelectedDropdownOption(selectedField);

    if (gridRef.current) {
      const columnApi = gridRef.current.columnApi;
      const rowGroupColumns = columnApi.getAllGridColumns().filter(col => col.getColDef().rowGroup);

      // Remove existing row group columns
      rowGroupColumns.forEach(col => columnApi.removeRowGroupColumn(col.getColId()));

      // Add the selected field as a row group column if it's not "none"
      if (selectedField !== 'none') {
        columnApi.addRowGroupColumn(selectedField);
      }
    }
  };

  // Synchronize dropdown with current row grouping
  const onColumnRowGroupChanged = useCallback(() => {
    if (gridRef.current) {
      const columnApi = gridRef.current.columnApi;
      const rowGroupColumns = columnApi.getRowGroupColumns();

      // Check if the grouped column is in the dropdown options
      if (rowGroupColumns.length > 0) {
        const currentGroupedColumn = rowGroupColumns[rowGroupColumns.length - 1].getColId();
        const validOptions = dropdownOptions.map(option => option.value);

        if (validOptions.includes(currentGroupedColumn)) {
          setSelectedDropdownOption(currentGroupedColumn);
        } else {
          setSelectedDropdownOption('none'); // Set to 'none' if the column is not valid
        }
      } else {
        setSelectedDropdownOption('none'); // Set to 'none' if no columns are grouped
      }
    }
  }, [dropdownOptions]);

  // Add and remove event listeners for column row group changes
  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.addEventListener('columnRowGroupChanged', onColumnRowGroupChanged);
    }

    return () => {
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.removeEventListener('columnRowGroupChanged', onColumnRowGroupChanged);
      }
    };
  }, [onColumnRowGroupChanged]);


  const gridOptions = {
    suppressContextMenu: true
  }
  const filteredRowData = useMemo(() => {
    if (!selectedTenant) return rowData;
    console.log("selectedTenant", selectedTenant)
    // convert selectedTenant to number
    return rowData.filter((row: any) => row.tenantName === (selectedTenant));
  }, [rowData, selectedTenant]);

  // console.log("filteredRowData Data:", filteredRowData);
  return (
    <div style={containerStyle}>
      <div>
        <Header title="Resource Cost" subtitle={`${org}`} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex' }}>
          <div className={styles.payerBox}>
            <Typography variant='body2' className={styles.costText}>
              Payer Account Id   :  {payerData.column2}  (  {payerData.column1}  )
            </Typography>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', marginTop: '20px', alignItems: 'center', gap: '10px' }}>
  
    <Tooltip title='Clear Filters'>
      <Button
        variant="outlined"
        className='mui-buttons'
        style={{
          fontSize: '0.875rem',
          height: '34px',
          borderRadius: '25px',
          fontWeight: '700',
          border: '1px solid #1F5493',
          textTransform: 'none',
          padding: '0 12px',
        }}
        onClick={() => handleClearAllFilters('clearFilter')}
      >
        Clear Filters
      </Button>
    </Tooltip>

  <Tooltip title='Filters'>
    <div style={{
      height: '29px',
      width: '29px',
      backgroundColor: '#1F5493',
      border: '1px solid #1F5493',
      borderRadius: '20px',
      textAlign: 'center'
    }}>
      <FilterListIcon
        className='filter-icon'
        style={{ marginTop: '4px', color: '#ffffff', height: '0.8em', width: '0.8em' }}
      />
    </div>
  </Tooltip>

  {accountId && filterApplied && (
    <Box className={filterApplied ? styles.accountIdFilterBoxApplied : styles.accountIdFilterBox}>
      <Tooltip title='Usage Account Id'>
        <Typography className={filterApplied ? styles.accountIdFilterButtonApplied : styles.accountIdFilterButtonNotApplied}>
          {accountId}
        </Typography>
      </Tooltip>
      <Tooltip title='Clear Filter'>
        <IconButton
          className={filterApplied ? styles.accountIdFilterButtonApplied : styles.accountIdFilterButtonNotApplied}
          onClick={() => handleClearAllFilters('column')}
        >
          <ClearIcon className={styles.accountIdFilterIcon} />
        </IconButton>
      </Tooltip>
    </Box>
  )}
          {
            <Box className={liveresourceClicked ? styles.liveboxclick : styles.livebox}>
              <Tooltip title={liveresourceClicked ? 'Filtered by Live resources' : 'View live Resources'}>
                <Button className={liveresourceClicked ? styles.liveresourceFilter : styles.liveresourcebutton} variant="outlined" onClick={handleLiveResources}>Live Resources</Button>
              </Tooltip>
              {liveresourceClicked &&
                <Tooltip title='Clear Filter'>
                  <IconButton className={liveresourceClicked ? styles.accountIdFilterButtonApplied : styles.accountIdFilterButtonNotApplied} onClick={() => handleClearAllFilters('liveresource')}>
                    <ClearIcon className={styles.accountIdFilterIcon} />
                  </IconButton>
                </Tooltip>
              }
            </Box>
          }

          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              className='resource-datepicker'
              label="Start Date"
              autoFocus
              sx={{
                marginRight: '10px',
              }}
              defaultValue={dayjs(startDate)}
              onChange={handleStartDateChange} />
            <DatePicker
              className='resource-datepicker'
              label="End Date"
              autoFocus
              defaultValue={dayjs(endDate)}
              onChange={handleEndDateChange}
            />
          </LocalizationProvider> */}
   <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <DatePicker
          label="Start Date"
          autoFocus
          value={dayjs(startDate)}
          onChange={handleStartDateChange}
          sx={{
            marginRight: '10px',
            '& .MuiOutlinedInput-root': {
              width: '160px',         // Set the width
              height: '34px',         // Set the height
              borderRadius: '25px',   // Set the border-radius
              padding: '0px',         // Adjust padding to ensure proper fit
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#1F5493', // Custom border color
            },
            '& .MuiFormLabel-root': {
              color: '#1F5493',
              fontWeight: 'bold',
            },
            '& .MuiIconButton-root': {
              color: '#1F5493',
            },
            '& input': {
              fontSize: '0.875rem',   // Set the font size smaller
            },
            '& .MuiInputAdornment-root': {
              padding: '5px',         // Add padding to the input adornment
            },
          }}
        />
        <DatePicker
          label="End Date"
          autoFocus
          value={dayjs(endDate)}
          onChange={handleEndDateChange}
          sx={{
            '& .MuiOutlinedInput-root': {
              width: '160px',         // Set the width
              height: '34px',         // Set the height
              borderRadius: '25px',   // Set the border-radius
              padding: '0px',         // Adjust padding to ensure proper fit
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#1F5493', // Custom border color
            },
            '& .MuiFormLabel-root': {
              color: '#1F5493',
              fontWeight: 'bold',
            },
            '& .MuiIconButton-root': {
              color: '#1F5493',
            },
            '& input': {
              fontSize: '0.875rem',   // Set the font size smaller
            },
            '& .MuiInputAdornment-root': {
              padding: '5px',         // Add padding to the input adornment
            },
          }}
        />
      </Box>
    </LocalizationProvider>
        </div>
      </div>
      <div className={styles.costBox1}>
        <div className={styles.costBox3}>
          <div className={styles.costBox2}>
            <Typography variant='body2' className={styles.costText}>
              Incurred Cost ($) : {totalCostValue}
            </Typography>
          </div>
          {
            isCurrentMonth && <div className={styles.costBox2}>
              <Typography variant='body2' className={styles.costText}>
                Forecasted Cost ($) : {forecastedCost}
              </Typography>
            </div>
          }
        </div>


        <div className={styles.costBox1}>
        {role === "SuperAdmin" && (
          <div className={styles.costBox2}>
            <select
              value={selectedTenant || ""}
              onChange={(e) => setSelectedTenant(e.target.value)}
              style={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#1F5493',
                cursor: 'pointer',
              }}
            >
              <option value="">All Tenants</option>
              {tenantsFromDb.map((tenant) => (
                <option key={tenant.id} value={tenant.name}>
                  {tenant.name}
                </option>
              ))}
            </select>
          </div>
        )}  

        <div className={styles.costBox2}>
          {
            dropdownOptions && (<DropdownComponent
              selectedDropdownOption={selectedDropdownOption}
              onChange={handleDropdownChange}
              dropdownOptions={dropdownOptions}
            />)
          }

        </div>
        </div>
      </div>


      {loading ? (<Loader />) : (
        <div className="ag-theme-quartz resourcecost" style={gridStyle}>
          <AgGridReact
            ref={gridRef}
            rowData={filteredRowData}
            autoGroupColumnDef={autoGroupColumnDef}
            columnDefs={columnDefs}
            rowGroupPanelShow={"always"}
            sideBar={sideBar}
            defaultColDef={defaultColDef}
            onGridReady={onGridReady}
            suppressAggFuncInHeader={true}
            gridOptions={gridOptions}
            masterDetail={true}
            detailCellRendererParams={detailCellRendererParams}
            isRowMaster={isRowMaster}
            detailRowAutoHeight={true}
          />
        </div>
      )
      }
    </div>
  );
};

export default ResourceCostPage;
